import React from "react";
import "./about.scss";

import aboutDoseImg from "../../assets/imgs/about1.png";
import doseLogo from "../../assets/imgs/logo.png";

const About = () => {
    return (
        <section className="container bgWhite about">
            <div className="grid wide">
                <div className="row center">
                    <div className="col l-4 m-12 c-12">
                        <div className="about__img">
                            <img src={aboutDoseImg} alt="what is DOSE Token" />
                        </div>
                    </div>
                    <div className="col l-8 m-12 c-12">
                        <div className="about__text">
                            <h3 className="textBox__title">
                                What is DOSE Token?
                            </h3>
                            <p className="textBox__text">
                                DOSE is an ERC-20 Fungible Token (FT) of
                                purchase, utility and action. It is the heart of
                                the OliveX gamified fitness ecosystem.Players
                                will receive DOSE tokens for completing workout
                                based gameplay in Dustland Runner, Dustland
                                Rider, 22 Pushups and other experiences. These
                                tokens can be used to unlock items, purchase
                                NFTs and participate in special events and game
                                modes.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="row center whyDose">
                    <div className="col l-6 m-12 c-12">
                        <div className="about__text">
                            <h3 className="textBox__title">Why DOSE?</h3>
                            <div className="textBox__text">
                                <p>
                                    DOSE is an acronym for the chemicals you
                                    release when you play an exercise game like
                                    Dustland Runner that makes you feel good.
                                </p>

                                <div className="whyDose__list">
                                    <span className="whyDose__item">
                                        Dopamine
                                    </span>
                                    <span className="whyDose__item">
                                        Oxytocin
                                    </span>
                                    <span className="whyDose__item">
                                        Serotonin
                                    </span>
                                    <span className="whyDose__item">
                                        Endorphin
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col l-6 m-12 c-12">
                        <div className="about__img">
                            <iframe
                                width="560"
                                height="315"
                                src="https://www.youtube.com/embed/IWNtDrUD3XU"
                                title="YouTube video player"
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                            ></iframe>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default About;
